import { createReducer } from 'utilities';
import * as TYPES from './constants';

const initialState = {
  user: null
};

const reducer = createReducer(initialState, {
  [TYPES.LOGIN_SUCCESS](state, { user }) {
    return {
      ...state,
      user,
    }
  }
});

export default reducer;


// WEBPACK FOOTER //
// ./src/ducks/auth/reducer.js